import DSDialogContent from '../design-system/DSDialogContent';
import DSDialogTitle from '../design-system/DSDialogTitle';
import { DSTypography } from '../design-system/Typography';
import DSDialog from '../design-system/DSDialog';

type ErrorDialogProps = {
  errorTitle: string;
  errorReason: string;
  isErrorDialogOpen: boolean;
  handleClose: () => void;
  onClick?: () => void;
  note?: string;
};
const ErrorDialog = ({
  errorTitle,
  errorReason,
  isErrorDialogOpen,
  handleClose,
  onClick,
  note,
}: ErrorDialogProps) => {
  return (
    <DSDialog
      maxWidth="md"
      open={isErrorDialogOpen}
      onClose={() => handleClose()}
    >
      <DSDialogTitle color="error">{errorTitle}</DSDialogTitle>
      <DSDialogContent>
        <DSTypography
          variant="body2"
          color="error"
          onClick={onClick}
          sx={{
            ...(onClick && {
              textDecorationLine: 'underline',
              cursor: 'pointer',
            }),
          }}
        >
          {errorReason}
        </DSTypography>
        {note && (
          <DSTypography variant="body2" sx={{ mt: 1 }}>
            {note}
          </DSTypography>
        )}
      </DSDialogContent>
    </DSDialog>
  );
};
export default ErrorDialog;
